<template>
    <section
        v-if="customer"
        class="l-section l-section--main o-deliveryAddress"
    >
        <form @submit.prevent="handleSubmit">
            <div
                class="l-container l-container--main l-container--horizontalPaddings"
            >
                <div class="l-row l-row--center">
                    <div class="l-row__column l-row__column--6">
                        <div class="a-mobile">
                            <h2 class="a-title">Twoje adresy</h2>
                            <select class="a-select" v-model="addressId">
                                <option v-if="canAddNewAddress" value="-1"
                                    >-- dodaj nowy adres --</option
                                >
                                <option
                                    v-for="address in addresses"
                                    v-bind:key="address.id"
                                    :value="address.id"
                                >
                                    {{ address.address }}
                                </option>
                            </select>
                            <br /><br />
                            <template v-if="+addressId === -1">
                                <div class="l-row l-row--wrap">
                                    <div
                                        class="l-row__column l-row__column--12"
                                    >
                                        <h2 class="a-title">Uzupełnij dane</h2>
                                        <h3 class="a-title a-title--subtitle">
                                            Osoba kontaktowa
                                        </h3>
                                    </div>
                                    <div class="l-row__column l-row__column--6">
                                        <a-control
                                            label="Imię"
                                            v-model="contactPersonFirstName"
                                            id="control-contactPersonFirstName"
                                            ref="contactPersonFirstName"
                                        />
                                    </div>
                                    <div class="l-row__column l-row__column--6">
                                        <a-control
                                            label="Nazwisko"
                                            v-model="contactPersonLastName"
                                            id="control-contactPersonLastName"
                                            ref="contactPersonLastName"
                                        />
                                    </div>
                                    <div class="l-row__column l-row__column--6">
                                        <a-control
                                            type="mask"
                                            :mask="'+48#########'"
                                            label="Telefon"
                                            placeholder="np. +48987654321"
                                            v-model="contactPersonPhone"
                                            id="control-contactPersonPhone"
                                            ref="contactPersonPhone"
                                        />
                                    </div>
                                    <div class="l-row__column l-row__column--6">
                                        <a-control
                                            label="Adres e-mail"
                                            v-model="contactPersonEmail"
                                            id="control-contactPersonEmail"
                                            ref="contactPersonEmail"
                                        />
                                    </div>
                                </div>
                                <h2 class="a-title">Informacje o dostawie</h2>
                                <br />
                                <div class="a-control">
                                    <label
                                        for=""
                                        class="a-label a-control__label"
                                        >Adres dostawy</label
                                    >
                                    <gmap-autocomplete
                                        class="a-control__input"
                                        ref="autocomplete"
                                        :options="{
                                            fields: [
                                                'geometry',
                                                'address_components',
                                                'formatted_address'
                                            ]
                                        }"
                                        @place_changed="geolocateStart"
                                        @focus="changeAutocompleteAttr"
                                        placeholder="Szukaj w mapach Google"
                                        :value="autocomplete"
                                        :select-first-on-enter="true"
                                    />
                                </div>
                                <o-notifications :is-static="true" />
                                <div class="l-row">
                                    <div class="l-row__column l-row__column--6">
                                        <a-control
                                            label="Ulica"
                                            id="delivery-street"
                                            v-model="deliveryStreet"
                                            autocomplete="nope"
                                        />
                                    </div>
                                    <div class="l-row__column l-row__column--6">
                                        <a-control
                                            label="Numer"
                                            id="delivery-number"
                                            v-model="deliveryNumber"
                                            autocomplete="nope"
                                        />
                                    </div>
                                </div>
                                <div class="l-row">
                                    <div class="l-row__column l-row__column--6">
                                        <a-control
                                            label="Kod pocztowy"
                                            id="delivery-postcode"
                                            v-model="deliveryPostcode"
                                            autocomplete="nope"
                                        />
                                    </div>
                                    <div class="l-row__column l-row__column--6">
                                        <a-control
                                            label="Miasto"
                                            id="delivery-city"
                                            v-model="deliveryCity"
                                            autocomplete="nope"
                                        />
                                    </div>
                                </div>
                                <template
                                    v-if="
                                        geometry &&
                                            geometry.lat &&
                                            geometry.lng &&
                                            google
                                    "
                                >
                                    <p class="a-text">
                                        Ustaw pinezkę na mapie, aby pomóc
                                        naszemu dostawcy szybciej dotrzeć do
                                        Twojej firmy.
                                    </p>
                                    <br />
                                    <div class="a-control">
                                        <p class="a-label a-control__label">
                                            Wskaż wejście do biura
                                        </p>
                                        <GmapMap
                                            class="a-control__map"
                                            :center="mapCenter"
                                            :zoom="15"
                                            map-type-id="terrain"
                                            ref="gmap"
                                        >
                                            <GmapMarker
                                                :position="geometry"
                                                :clickable="true"
                                                :draggable="true"
                                                :icon="{
                                                    url: require('@/assets/marker.png')
                                                }"
                                                @dragend="updateCoordinates"
                                            />
                                        </GmapMap>
                                    </div>
                                    <br />
                                </template>
                            </template>
                        </div>
                        <div
                            class="o-deliveryAddress__submit a-mobile__buttons"
                            :class="{
                                'o-deliveryAddress__submit--multiple': !isSecondStep
                            }"
                        >
                            <a-button
                                class="a-mobile__button"
                                v-if="!isSecondStep"
                                @click="returnToCart"
                            >
                                Powrót
                            </a-button>
                            <a-button
                                type="button"
                                @click="handleSubmit"
                                class="a-button a-button--primary a-mobile__button o-deliveryAddress__submitButton"
                                :is-processing="
                                    customerStatus ===
                                        'checkingAddressAvailability'
                                "
                            >
                                Sprawdź produkty dostępne dla tego adresu
                                <a-icon class="a-button__icon" icon="Right" />
                            </a-button>
                        </div>
                        <o-notifications
                            :is-static="true"
                            name="delivery-address"
                        />
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import { gmapApi } from 'gmap-vue'
export default {
    metaInfo: {
        title: 'Dodaj adres'
    },
    data() {
        return {
            geocoder: null,
            autocomplete: '',
            companySize: '1', // variable is present in modules and is sent to backend but doesnt do anything for now. Leaving it with default value.
            mapCenter: {
                lat: 0,
                lng: 0
            },
            deliveryStreet: '',
            deliveryNumber: '',
            deliveryPostcode: '',
            deliveryCity: '',
            geometry: { lat: 0, lng: 0 },
            addressId: -1,
            contactPersonFirstName: '',
            contactPersonLastName: '',
            contactPersonPhone: '',
            contactPersonEmail: ''
        }
    },
    watch: {
        google: {
            deep: true,
            handler() {
                if (this.isSecondStep) {
                    this.initGeocoder()
                }
            }
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 1024
        },
        isSecondStep() {
            return this.$route.name === 'delivery-address'
        },
        customer() {
            return this.$store.getters.customer
        },
        customerStatus() {
            return this.$store.getters.customerStatus
        },
        address() {
            let address = ''
            const street = this.$store.getters.customerAddressField(
                this.addressId,
                'street'
            )
            const number = this.$store.getters.customerAddressField(
                this.addressId,
                'number'
            )
            const postcode = this.$store.getters.customerAddressField(
                this.addressId,
                'postcode'
            )
            const city = this.$store.getters.customerAddressField(
                this.addressId,
                'city'
            )
            if (street) {
                address = `${street} `
            }
            if (number) {
                address = `${address}${number}, `
            }
            if (postcode) {
                address = `${address}${postcode}`
            }
            if (city) {
                address = `${address} ${city}`
            }
            return address
        },

        deliveryAddress() {
            let address = ''
            const street = this.deliveryStreet
            const number = this.deliveryNumber
            const postcode = this.deliveryPostcode
            const city = this.deliveryCity
            if (street) {
                address = `${street} `
            }
            if (number) {
                address = `${address}${number}, `
            }
            return `${address}${postcode} ${city}`
        },
        vatin() {
            return this.$store.getters.customer.vatin
        },
        companyName: {
            get() {
                return this.$store.getters.customer.companyName
            },
            set(value) {
                this.$store.dispatch('setCustomerField', {
                    field: 'companyName',
                    value
                })
            }
        },
        street: {
            get() {
                return this.$store.getters.customer.street
            },
            set(value) {
                this.$store.dispatch('setCustomerField', {
                    field: 'street',
                    value
                })
            }
        },
        postcode: {
            get() {
                return this.$store.getters.customer.postcode
            },
            set(value) {
                this.$store.dispatch('setCustomerField', {
                    field: 'postcode',
                    value
                })
            }
        },
        city: {
            get() {
                return this.$store.getters.customer.city
            },
            set(value) {
                this.$store.dispatch('setCustomerField', {
                    field: 'city',
                    value
                })
            }
        },
        google: gmapApi,
        addresses() {
            return this.$store.getters['companies/addresses']
        },
        canAddNewAddress() {
            return this.$store.getters['companies/oneInvoiceAddress']
        }
    },
    methods: {
        changeVatin() {
            this.$store.dispatch('resetState').then(() => {
                this.$router.push({ name: 'delivery-address' })
            })
        },
        updateCoordinates(location) {
            this.$set(this.geometry, 'lat', location.latLng.lat())
            this.$set(this.geometry, 'lng', location.latLng.lng())
        },
        setAddressComponents(components) {
            components.address_components.forEach(item => {
                if (item.types.includes('locality')) {
                    this.deliveryCity = item.long_name
                }
                if (item.types.includes('postal_code')) {
                    this.deliveryPostcode = item.long_name
                }
                if (item.types.includes('route')) {
                    this.deliveryStreet = item.long_name
                }
                if (item.types.includes('street_number')) {
                    this.deliveryNumber = item.long_name
                }
            })
            this.autocomplete = components.formatted_address
            // set geometry
            const lat = components.geometry.location.lat()
            const lng = components.geometry.location.lng()
            this.$set(this.geometry, 'lat', lat)
            this.$set(this.geometry, 'lng', lng)
            this.mapCenter = {
                lat,
                lng
            }
        },
        geolocateStart(autocompletedAddress) {
            if (autocompletedAddress.address_components) {
                this.setAddressComponents(autocompletedAddress)
            }
        },
        searchWithGeocoder(address) {
            this.geocoder.geocode(
                {
                    address: address
                },
                (responses, status) => {
                    if (
                        status ===
                        this.google.maps.places.PlacesServiceStatus.OK
                    ) {
                        // save customer address based on geocoder
                        this.setAddressComponents(responses[0])
                    }
                }
            )
        },
        initGeocoder() {
            if (this.google) {
                this.geocoder = new this.google.maps.Geocoder()
                this.searchWithGeocoder(this.address)
            }
        },
        handleSubmit() {
            // already created adress
            if (+this.addressId !== -1) {
                this.$store
                    .dispatch('addAddressWithId', {
                        addressId: this.addressId,
                        newAddress: !this.isSecondStep
                    })
                    .then(() => {
                        // check for supported days
                        const selectedAddress = this.addresses.find(
                            address => address.id === this.addressId
                        )
                        if (!selectedAddress) {
                            throw Error('No details in selected address')
                        }
                        this.$store
                            .dispatch('checkSupportedDaysAndSave', {
                                geometry: {
                                    lat: selectedAddress.latitude,
                                    lng: selectedAddress.longitude
                                },
                                warehouse: {
                                    id: selectedAddress.warehouse_id
                                },
                                companySize: this.companySize,
                                // check all days
                                days: 0,
                                // check if new address
                                newAddress: !this.isSecondStep
                            })
                            .then(res => {
                                this.$router.push({ name: 'cart' })
                            })
                            .catch(() => {
                                this.$store.dispatch('addNotification', {
                                    type: 'danger',
                                    content:
                                        'Nie mamy żadnego dostawcy w pobliżu. Skontaktuj się ze swoim opiekunem BOK.',
                                    name: 'delivery-address',
                                    limit: 0
                                })
                            })
                    })
                return
            }
            if (
                !this.geometry ||
                this.geometry.lat === 0 ||
                this.geometry.lng === 0
            ) {
                this.$scrollTo(this.$refs.autocomplete.$el, 500, {
                    offset: -65
                })
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Proszę wskazać prawidłowy adres dostawy.',
                    limit: 0
                })
                return
            }
            if (this.deliveryNumber === '') {
                this.$scrollTo(this.$refs.autocomplete.$el, 500, {
                    offset: -65
                })
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Proszę podać adres z numerem domu.',
                    limit: 0
                })
                return
            }
            if(!/^[0-9]{2}-[0-9]{3}$/g.test(this.deliveryPostcode)) {
                this.$scrollTo(this.$refs.autocomplete.$el, 500, {
                    offset: -65
                })
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Kod pocztowy musi mieć format XX-XXX',
                    limit: 0
                })
                return
            }
            this.$store
                .dispatch('checkAddressAvailability', {
                    newAddress: !this.isSecondStep,
                    deliveryStreet: this.deliveryStreet,
                    deliveryNumber: this.deliveryNumber,
                    deliveryPostcode: this.deliveryPostcode,
                    deliveryCity: this.deliveryCity,
                    geometry: this.geometry,
                    days: 0,
                    companySize: this.companySize,
                    // set contact person for address
                    contactPerson: {
                        first_name: this.contactPersonFirstName,
                        last_name: this.contactPersonLastName,
                        phone: this.contactPersonPhone,
                        email: this.contactPersonEmail
                    }
                })
                .then(() => {
                    // check current address is supported
                    if (this.isMobile) {
                        this.$router.push({
                            name: 'cart-mobile-week',
                            params: { address: this.addressId }
                        })
                    } else {
                        this.$router.push({ name: 'cart' })
                    }
                })
                .catch(error => {
                    if (this.$refs.autocomplete) {
                        this.$scrollTo(this.$refs.autocomplete.$el, 500, {
                            offset: -65
                        })
                    }
                    if (
                        Object.prototype.hasOwnProperty.call(
                            error,
                            'message'
                        ) &&
                        error.message === 'Location not availible'
                    ) {
                        this.$store.dispatch('addNotification', {
                            type: 'fail',
                            content:
                                'Niestety nie obsługujemy dostaw w wybranej lokalizacji.',
                            limit: 0
                        })
                    } else {
                        this.$store.dispatch('addNotification', {
                            type: 'danger',
                            content: 'Wystąpił błąd.'
                        })
                    }
                })
        },
        returnToCart() {
            this.$router.push({ name: 'cart' })
        },
        changeAutocompleteAttr() {
            this.$refs.autocomplete.$el.setAttribute('autocomplete', 'nope')
        }
    },
    created() {
        if (this.isSecondStep) {
            this.initGeocoder()
        }
        this.$store.dispatch('companies/fetchAddresses').then(() => {
            if (this.addresses.length > 0) {
                // set default address
                this.addressId = this.addresses[0].id
            }
        })
    }
}
</script>
